import { render } from "./TheBreadcrumb.vue?vue&type=template&id=31c4164a&scoped=true"
import script from "./TheBreadcrumb.vue?vue&type=script&lang=js"
export * from "./TheBreadcrumb.vue?vue&type=script&lang=js"

import "./TheBreadcrumb.vue?vue&type=style&index=0&id=31c4164a&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c4164a"]])

export default __exports__